/**
 * 路由路径常量集中定义。
 * 新增路由时必须在此文件注册，禁止在业务代码中硬编码路径字符串。
 */
export const ROUTE_PATHS = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  SEND_RESET_LINK: "/send-reset-link",
  RESET_PASSWORD: "/reset-password",
  VERIFY_EMAIL: "/verify-email",
  CHANGE_EMAIL: "/change-email",
  ACCOUNT_CONNECT: "/account/connect",
  ERROR: "/error",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  PRICING: "/pricing",
  EDUCATION: "/education",
  ONBOARDING: "/onboarding",

  ITEM_DETAIL: "/items/:itemId",

  MINE: "/mine",
  MINE_ALL: "/mine/all",
  MINE_SEARCH: "/mine/search",
  MINE_FOLDERS: "/mine/folders/:folderId",
  MINE_TAGS: "/mine/tags/:tagId",
  MINE_TRASH: "/mine/trash",
  MINE_WORKFLOW: "/mine/workflow",
  MINE_WORKFLOW_DETAIL: "/mine/workflow/:flowRuleId",
  MINE_DUPLICATES: "/mine/duplicates",
  MINE_PLUGINS: "/mine/plugins",
  MINE_PLUGIN_DETAIL: "/mine/plugins/:pluginId",
} as const;

export const ROUTE_SEGMENTS = {
  MINE_ALL: "all",
  MINE_SEARCH: "search",
  MINE_FOLDERS: "folders/:folderId",
  MINE_TAGS: "tags/:tagId",
  MINE_TRASH: "trash",
  MINE_WORKFLOW: "workflow",
  MINE_WORKFLOW_DETAIL: "workflow/:flowRuleId",
  MINE_DUPLICATES: "duplicates",
  MINE_PLUGINS: "plugins",
  MINE_PLUGIN_DETAIL: "plugins/:pluginId",
} as const;

export const buildMineFolderPath = (folderId: string) =>
  `/mine/folders/${folderId}`;

export const buildItemDetailPath = (itemId: string) =>
  `/items/${encodeURIComponent(itemId)}`;

export const buildMineTagPath = (tagId: string) => `/mine/tags/${tagId}`;

export const buildMineWorkflowPath = (flowRuleId: string) =>
  `/mine/workflow/${flowRuleId}`;

export const buildMinePluginPath = (pluginId: string) => `/mine/plugins/${pluginId}`;

export const ROUTE_PREFIXES = {
  MINE_FOLDERS: "/mine/folders/",
  MINE_TAGS: "/mine/tags/",
  MINE_PLUGINS: "/mine/plugins/",
} as const;
